import { createFileRoute } from "@tanstack/react-router";
import AGBPage from "@/pages/AGBPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/agb")({
  head: () =>
    buildRouteHead({
      title: "AGB | Allgemeine Geschäftsbedingungen Enno & Jens",
      description:
        "Allgemeine Geschäftsbedingungen der Agentur Enno & Jens für Webdesign, Hosting und SEO-Leistungen.",
      path: "/agb",
    }),
  component: AGBPage,
});
